import { DevToolsStatusBadge } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsStatusBadge';
import type { DevToolsBadgeVariant } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsStatusBadge/index.types';
import type { CallsStateBadgeProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/CallsTab/CallsStateBadge/index.types';
import React from 'react';

const STATE_VARIANTS: Record<string, DevToolsBadgeVariant> = {
  active: 'success',
  ringing: 'info',
  connecting: 'warning',
  held: 'warning',
  ended: 'error',
  failed: 'error',
};

/**
 * CallsStateBadge - Maps a call state onto a badge variant
 */
export const CallsStateBadge: React.FC<CallsStateBadgeProps> = ({ state }) => (
  <DevToolsStatusBadge label={state} variant={STATE_VARIANTS[state] ?? 'neutral'} />
);
